import React from "react";
import classes from "./PrepareCheckBox.module.scss";
import TeacherComment from "../../molecules/teacher-commnet/TeacherComment";
import charimage6 from "../../static/images/prepare/char-question-6.png";

import CheckBox, { CheckBoxItem } from "../../atoms/checkbox/CheckBox";

type PrepareCheckBoxProps = {
  checkboxForm: { [key: string]: 1 | 0 };
  onChange: (item: CheckBoxItem) => void;
};

const PrepareCheckBox: React.FC<PrepareCheckBoxProps> = ({
  checkboxForm,
  onChange,
}) => {
  // 親から渡された checkboxForm を元に value を設定
  const checkItems: CheckBoxItem[] = [
    {
      id: "1",
      name:
        "NISA口座を持っていない。または、NISA口座を持っているが投資していない",
      value: checkboxForm["1"] === 1,
    },
    {
      id: "2",
      name: "投資信託の銘柄の選び方が分からない",
      value: checkboxForm["2"] === 1,
    },
    {
      id: "3",
      name: "確定拠出年金（iDeCo・企業型DC)を利用していない",
      value: checkboxForm["3"] === 1,
    },
    {
      id: "4",
      name: "奨学金や助成制度がよくわからない",
      value: checkboxForm["4"] === 1,
    },
    {
      id: "5",
      name: "ふるさと納税を活用していない",
      value: checkboxForm["5"] === 1,
    },
    {
      id: "6",
      name: "学資保険を他の投資と比較せずに契約をした",
      value: checkboxForm["6"] === 1,
    },
    {
      id: "7",
      name: "子どもの将来に合わせた教育資金の設計ができていない",
      value: checkboxForm["7"] === 1,
    },
    {
      id: "8",
      name: "老後資金がどれくらい必要か分からない",
      value: checkboxForm["8"] === 1,
    },
    {
      id: "9",
      name: "保険を3年以上見直していない",
      value: checkboxForm["9"] === 1,
    },
    {
      id: "10",
      name: "住宅ローンを５年以上見直していない",
      value: checkboxForm["10"] === 1,
    },
    {
      id: "99",
      name: "上記のどれにもあてはまらない",
      value: checkboxForm["11"] === 1,
    },
  ];

  return (
    <div className={classes.container}>
      <TeacherComment
        image={charimage6}
        comment={[
          "ご回答いただきありがとうございました！最後に、当てはまる項目にチェックをつけてください！",
        ]}
      />
      <div className={classes.checkArea}>
        <div className={classes.checkTitle}>資産形成のチェックリスト</div>
        <CheckBox label={""} checkItem={checkItems} onChange={onChange} />
      </div>
    </div>
  );
};

export default PrepareCheckBox;
